module.exports = __webpack_public_path__ + "static/media/meritus-3.05003b68.jpg";